import MuiCard from '@mui/material/Card';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export interface CardProps {
  variant?: 'elevation' | 'outlined';
  // A level of the theme's shadow scale (docs/DESIGN.md §7): 1 cards at rest, 2 subtle surfaces,
  // 4 an elevated surface, 8 menus and popovers. A curated escape hatch, like `Text`'s `bold`, so a
  // view can pick a level without reaching past the facade with `sx: { boxShadow }` — a raw shadow
  // would drop the theme's umbra/penumbra/ambient stack. Ignored by MUI when `variant="outlined"`.
  elevation?: number;
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

export function Card({ variant = 'elevation', elevation, sx, children }: CardProps) {
  return (
    <MuiCard
      variant={variant}
      {...(elevation !== undefined ? { elevation } : {})}
      {...(sx !== undefined ? { sx } : {})}
    >
      {children}
    </MuiCard>
  );
}
